import React, { ReactNode } from "react";

interface CollectionCardGridProps {
  children: ReactNode;
  className?: string;
}

/**
 * Responsive collection card layout. Full rows use 1/2/3 columns; partial
 * last rows center as a group while keeping the same card width and gap.
 */
const CollectionCardGrid: React.FC<CollectionCardGridProps> = ({
  children,
  className = "",
}) => <div className={`collection-card-grid ${className}`.trim()}>{children}</div>;

export default CollectionCardGrid;
